module.exports = __webpack_public_path__ + "img/category_4.dd396e0a.svg";